// Automatisch gegenereerd door tools/generate-dto.mjs — niet handmatig wijzigen.
// Bij herGeneratie worden imports, constructor-body en static create bewaard.

import { IDomainDto } from './domain-dto.g';
import { IUserDto } from './user-dto.g';
import { IImageBoxDto } from './image-box-dto.g';
import { IMembershipLockEnumDto } from './membership-lock-enum-dto.g';
import { IAffiliationEnumDto } from './affiliation-enum-dto.g';

export const domainUserListDto = {
    requestedDomainUser_Guid: 'requestedDomainUser_Guid',
    domain_Guid: 'domain_Guid',
    guid: 'guid',
    nr: 'nr',
    name: 'name',
    isAdmin: 'isAdmin',
    isOwner: 'isOwner',
    lastVisit: 'lastVisit',
    startDate: 'startDate',
    endDate: 'endDate',
    startDay: 'startDay',
    endDay: 'endDay',
    inactive: 'inactive',
    permanent: 'permanent',
    guestEndAuto: 'guestEndAuto',
    accessBlocked: 'accessBlocked',
    twoFactorRequired: 'twoFactorRequired',
    endDateLock: 'endDateLock',
    deleted: 'deleted',
    domainDto: 'domainDto',
    ownerDto: 'ownerDto',
    userDto: 'userDto',
    domainPhotoBoxDto: 'domainPhotoBoxDto',
    profilePhotoBoxDto: 'profilePhotoBoxDto',
    userPhotoBoxDto: 'userPhotoBoxDto',
    affiliation: 'affiliation',
    organisationContact_Guid: 'organisationContact_Guid',
    organisation_Name: 'organisation_Name',
} as const;

export type TDomainUserListDto = (typeof domainUserListDto)[keyof typeof domainUserListDto];

export interface IDomainUserListDto {
    [domainUserListDto.requestedDomainUser_Guid]: string | null;
    [domainUserListDto.domain_Guid]: string | null;
    [domainUserListDto.guid]: string | null;
    [domainUserListDto.nr]: number | null;
    [domainUserListDto.name]: string | null;
    [domainUserListDto.isAdmin]: boolean | null;
    [domainUserListDto.isOwner]: boolean | null;
    [domainUserListDto.lastVisit]: string | null;
    [domainUserListDto.startDate]: string | null;
    [domainUserListDto.endDate]: string | null;
    [domainUserListDto.startDay]: string | null;
    [domainUserListDto.endDay]: string | null;
    [domainUserListDto.inactive]: boolean | null;
    [domainUserListDto.permanent]: boolean | null;
    [domainUserListDto.guestEndAuto]: boolean | null;
    [domainUserListDto.accessBlocked]: boolean | null;
    [domainUserListDto.twoFactorRequired]: boolean | null;
    [domainUserListDto.endDateLock]: IMembershipLockEnumDto | null;
    [domainUserListDto.deleted]: boolean | null;
    [domainUserListDto.domainDto]: IDomainDto | null;
    [domainUserListDto.ownerDto]: IUserDto | null;
    [domainUserListDto.userDto]: IUserDto | null;
    [domainUserListDto.domainPhotoBoxDto]: IImageBoxDto | null;
    [domainUserListDto.profilePhotoBoxDto]: IImageBoxDto | null;
    [domainUserListDto.userPhotoBoxDto]: IImageBoxDto | null;
    [domainUserListDto.affiliation]: IAffiliationEnumDto | null;
    [domainUserListDto.organisationContact_Guid]: string | null;
    [domainUserListDto.organisation_Name]: string | null;
}

export class DomainUserListDto
    implements IDomainUserListDto
{
    [domainUserListDto.requestedDomainUser_Guid]: string | null = null;
    [domainUserListDto.domain_Guid]: string | null = null;
    [domainUserListDto.guid]: string | null = null;
    [domainUserListDto.nr]: number | null = null;
    [domainUserListDto.name]: string | null = null;
    [domainUserListDto.isAdmin]: boolean | null = null;
    [domainUserListDto.isOwner]: boolean | null = null;
    [domainUserListDto.lastVisit]: string | null = null;
    [domainUserListDto.startDate]: string | null = null;
    [domainUserListDto.endDate]: string | null = null;
    [domainUserListDto.startDay]: string | null = null;
    [domainUserListDto.endDay]: string | null = null;
    [domainUserListDto.inactive]: boolean | null = null;
    [domainUserListDto.permanent]: boolean | null = null;
    [domainUserListDto.guestEndAuto]: boolean | null = null;
    [domainUserListDto.accessBlocked]: boolean | null = null;
    [domainUserListDto.twoFactorRequired]: boolean | null = null;
    [domainUserListDto.endDateLock]: IMembershipLockEnumDto | null = null;
    [domainUserListDto.deleted]: boolean | null = null;
    [domainUserListDto.domainDto]: IDomainDto | null = null;
    [domainUserListDto.ownerDto]: IUserDto | null = null;
    [domainUserListDto.userDto]: IUserDto | null = null;
    [domainUserListDto.domainPhotoBoxDto]: IImageBoxDto | null = null;
    [domainUserListDto.profilePhotoBoxDto]: IImageBoxDto | null = null;
    [domainUserListDto.userPhotoBoxDto]: IImageBoxDto | null = null;
    [domainUserListDto.affiliation]: IAffiliationEnumDto | null = null;
    [domainUserListDto.organisationContact_Guid]: string | null = null;
    [domainUserListDto.organisation_Name]: string | null = null;

    private constructor(
        modelData: any, // TODO: vervang door IDomainUserListData
    ) {
        // TODO: map van modelData naar DTO properties
        // Voorbeeld: this[domainUserListDto.guid] = modelData[domainuserlistData.guid];
    }

    static create(modelData?: any | null): IDomainUserListDto | null {
        return modelData ? new DomainUserListDto(modelData) : null;
    }
}
